module.exports = __webpack_public_path__ + "images/dd0f076930e233b0051a55907bfc3690-Paradisus.png";